/*** Mobile Navigation ***/

window.slideNav = (function () {

  var selectors = {
    container: '#PageContainer',
    navWrapper: '.slide-nav__overflow',
    nav: '#SlideNav',
    toggleBtn: '.js-toggle-slide-nav', 
    subNavToggleBtn: '.js-toggle-submenu',
  };

  var classes = {
    subNavLink: 'slide-nav__sublist-link',
    return: 'slide-nav__return-btn',
    isActive: 'is-active',
    isOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open'
  };

  var namespace = '.slideNav';

  var isTransitioning;
  var activeSubNav;
  var activeTrigger;
  var pageSlide = false;
  var menuLevel = 1;
  var container;
  var navWrapper;
  var toggleBtns;
  var subNavToggleBtns;
  var activeMenuToggle = null;

  function init () {

    container = document.querySelector(selectors.container);
    navWrapper = document.querySelector(selectors.navWrapper);

    toggleBtns = document.querySelectorAll(selectors.toggleBtn);

    subNavToggleBtns = document.querySelectorAll(selectors.subNavToggleBtn);

    toggleBtns.forEach(btn => {
      btn.addEventListener('click', toggleNav);
      
    });

    subNavToggleBtns.forEach(btn => {
      btn.addEventListener('click', toggleSubNav);
    });
  }

  function toggleNav (evt) {
    activeMenuToggle = evt.currentTarget;
    if (activeMenuToggle.classList.contains(classes.isActive)) {
      closeNav();
    } else {
      openNav();
    }
  }

  function openNav (evt) {

    // Get all elements to hide when menu opens
    var elements = [
      //document.querySelectorAll('.section'),
      document.querySelector('.tp-widget-wrapper'),
      document.querySelector('.promo-banner'),
      document.querySelector('.back-to-top')
  ];
  
  // Loop through each NodeList in elements
  elements.forEach(function(nodeList) {
      // Loop through each element in the NodeList
      nodeList.forEach(function(element) {
          element.style.display = 'none';
      });
  }); 

    toggleBtns.forEach(btn => {
      btn.classList.add(classes.isActive);
    });

      navWrapper.classList.add(classes.isOpen);

    if (pageSlide) {
      var navWrapperHeight = document.querySelector(selectors.navWrapper).clientHeight;
      container.style.transform = 'translate3d(0, ' + navWrapperHeight + 'px, 0)';
    }

    navWrapper.setAttribute('tabindex', '-1');
    navWrapper.focus();

    // close on escape
    window.on('keyup' + namespace, function (evt) {
      if (evt.keyCode === 27) {
        closeNav();
      }
    });
  }

  function closeNav () {


     // Get all elements
    var elements = [
      //document.querySelectorAll('.section'),
      document.querySelector('.tp-widget-wrapper'),
      document.querySelector('.promo-banner'),
      document.querySelector('.back-to-top')
  ];
  
  // Loop through each NodeList in elements
  elements.forEach(function(nodeList) {
      // Loop through each element in the NodeList
      nodeList.forEach(function(element) {
          element.style.display = 'block';
      });
  }); 

    toggleBtns.forEach(btn => {
      btn.classList.remove(classes.isActive);
    });


      navWrapper.classList.remove(classes.isOpen);


    if (pageSlide) {
      container.removeAttribute('style');
    }

    activeMenuToggle.focus();
    activeMenuToggle = null;

    window.off('keyup' + namespace);
  }

  function toggleSubNav (evt) {
    if (isTransitioning) {
      return;
    }

    var toggleBtn = evt.currentTarget;
    var isReturn = toggleBtn.classList.contains(classes.return);
    isTransitioning = true;

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      var btns = document.querySelectorAll(selectors.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]');
      btns.forEach(btn => {
        btn.classList.remove(classes.isActive);
      });

      var menus = document.querySelectorAll('.slide-nav__dropdown[data-level="' + (menuLevel) + '"]');
      menus.forEach(menu => {

          menu.classList.remove(classes.isActive);

      });

      if (activeTrigger) {
        activeTrigger.classList.remove(classes.isActive);
      }
    } else {
      toggleBtn.classList.add(classes.isActive);

      var dropdown = toggleBtn.nextElementSibling;

        dropdown.classList.add(classes.isActive);

    }

    activeTrigger = toggleBtn;

    goToSubnav(toggleBtn.dataset.target);
  }

  function goToSubnav (target) {
    var targetMenu = target
      ? document.querySelector('.slide-nav__dropdown[data-parent="' + target + '"]')
      : document.querySelector(selectors.nav);

    menuLevel = targetMenu.dataset.level ? parseInt(targetMenu.dataset.level) : 1;

    activeSubNav = targetMenu;

    // Unused?
    // var $elementToFocus = target
    //   ? $targetMenu.find('.' + classes.subNavLink + ':first')
    //   : $activeTrigger;

    var translateMenuHeight = targetMenu.clientHeight;

    var openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;

    navWrapper.style.height = translateMenuHeight + 'px';
    navWrapper.classList.remove(classes.thirdNavShowing);
    navWrapper.classList.add(openNavClass);

    if (!target) {
      // Show top level nav
      navWrapper.classList.remove(classes.thirdNavShowing);
      navWrapper.classList.remove(classes.subNavShowing);
    }

    isTransitioning = false;

    // Match height of subnav
    if (pageSlide) {
      container.style.transform = 'translate3d(0, ' + translateMenuHeight + 'px, 0)';
    }
  }

  function unload () {
    window.off(namespace);
  }

  function prepareTransition (el, callback) {
    el.addEventListener('transitionend', removeClass);
  
    function removeClass (evt) {
      el.classList.remove('is-transitioning');
      el.removeEventListener('transitionend', removeClass);
    }
  
    el.classList.add('is-transitioning');
    el.offsetWidth; // check offsetWidth to force the style rendering
  
    if (typeof callback === 'function') {
      callback();
    }
  }

  return {
    init: init,
    unload: unload
  };
})();

window.slideNav.init();